import SandboxScreen from 'features/myVaro/screens/Sandbox/SandboxScreen';
import React from 'react';

export default function Page() {
  return <SandboxScreen />;
}
